import { shallowMount } from "@vue/test-utils";
import MensajeErrorSolicitudCuenta from "@/views/MensajeErrorSolicitudCuenta";

describe("MensajeErrorSolicitudCuenta component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(MensajeErrorSolicitudCuenta);
  });

  it("Renders del component MensajeErrorSolicitudCuenta", () => {
    expect(wrapper).toBeDefined();
  });
});
